<template>
  <div>
    <div class="row">
      Resultados
    </div>
    <div class="row">
      <div class="col-md-6">
        <a v-for="category in championship.categories" @click="select(category)" class="btn btn-default"
        :class="{'active': category_selected.code == category.code }">{{category.name}}</a>
      </div>

      <div class="col-md-6">
        <a @click="settypeScore('GROSS','strokeplay')" class="btn btn-default" :class="{'active': typeScore == 'GROSS' }">Strokeplay Gross</a>
        <a @click="settypeScore('NETO','strokeplay')" class="btn btn-default"  :class="{'active': typeScore == 'NETO' }">Strokeplay Neto</a>
        <a @click="settypeScore('GROSS','stableford')" class="btn btn-default" :class="{'active': typeScore == 'stablefordGROSS' }">Stableford Gross</a>
        <a @click="settypeScore('NETO','stableford')" class="btn btn-default"  :class="{'active': typeScore == 'stablefordNETO' }">Stableford Neto</a>

      </div>
    </div>
    <div class="row" v-if="scoreboard.length">
      <div class="col-md-12">
        <hr>
        <table class="table table-bordered table-condensed table-hover">
          <tr>
            <th class="center">Pos</th>
            <th class="center">País</th>
            <th class="center">Jugador</th>
            <th class="center">Categoría</th>
            <th class="center">Handicap</th>
            <th class="center">Par</th>
            <th class="center">R1</th>
            <th class="center">Total</th>
          </tr>
          <tr v-for="player in scoreboard">
            <td class="center">{{ player.position }}</td>
            <td class="center"><span class="flag-icon flag-icon-{{player.player.country.code | lowercase}}"></span></td>
            <td>{{player.player.surname}} {{player.player.mothers_surname}} {{ player.player.name}} {{player.player.middle_name}}</td>
            <td class="center">{{player.category.code}}</td>
            <td class="center">{{player.handicap}}</td>
            <td class="center">{{player.par == 1000 ? '' : player.par | diff}}</td>
            <td class="center">{{player.round1}}</td>
            <td class="center">{{player.total}}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>
<style>

</style>
<script>
  import configure from '../configure'
  import {
    getCurrentChampionship,
    getCurrentDate,
    getCurrentCourse} from '../vuex/getters'
  import * as actions from '../vuex/actions'
  export default{
    vuex: {
      getters: {
        championship: getCurrentChampionship,
        date: getCurrentDate,
        course: getCurrentCourse
      },
      actions

    },
    data() {
      return {
        scoreboard: [],
        categories: [],
        category_selected: false,
        typeScore: 'GROSS',
        typeGame: 'strokeplay'
      }
    },
    methods: {
      getScoreboard() {
        this.setLoading(true);
        this.$http.get(
          configure.api_url +
           'scoreboards?category=' + this.category_selected.code +
            '&type=' + this.typeScore +
            '&typegame=' + this.typeGame +
            '&championship_id=' + this.championship.id +
            '&course_id=' + this.course.id
        ).then((result) => {
          this.scoreboard = result.data
          this.setLoading(false)
        }, (error) => {
          alert('Error getting scoreboard')
          this.setLoading(false)
        })
      },
      select(category) {
        this.category_selected = category
        this.getScoreboard()
      },
      hasScore(element) {

      },
      settypeScore(type, game) {
        this.typeScore = type
        this.typeGame = game
        this.getScoreboard()
      }

    }
  }
</script>



/** WEBPACK FOOTER **
 ** ResultList.vue?17dc3a6e
 **/